import { BillingHistoryInterface } from '@interfaces/Membership.interface';

export const PAYMENT_STATUS = {
  open: 'OPEN',
  paid: 'PAID'
} as const;

export const handleFilters = (
  filters: { [key: string]: unknown } = {},
  resData: BillingHistoryInterface[]
) => {
  return resData.filter((data) => {
    const { invoice_number, created_at_start, created_at_end, status } =
      filters;
    if (invoice_number && !data.number.includes(invoice_number as string)) {
      return false;
    }
    const dateToCheck = new Date(data.created);
    dateToCheck.setHours(0, 0, 0, 0);

    if (created_at_start && created_at_end) {
      const startDate = new Date(created_at_start as string);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(created_at_end as string);
      endDate.setHours(23, 59, 59, 999);

      if (!(dateToCheck >= startDate && dateToCheck <= endDate)) {
        return false;
      }
    } else {
      if (created_at_start) {
        const startDate = new Date(created_at_start as string);
        startDate.setHours(0, 0, 0, 0);
        if (dateToCheck < startDate) {
          return false;
        }
      }
      if (created_at_end) {
        const endDate = new Date(created_at_end as string);
        endDate.setHours(23, 59, 59, 999);
        if (dateToCheck > endDate) {
          return false;
        }
      }
    }
    if (status !== undefined) {
      if (
        typeof status === 'string' &&
        data.status.toUpperCase() !== status.toUpperCase()
      ) {
        return false;
      }
    }

    return true;
  });
};
